import Input from 'antd/es/input/Input';
import TextArea from 'antd/es/input/TextArea';
import { useEffect, useState } from 'react';
import { ExamPartImportRequest } from '../../../model/request';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../../redux/store/store';
import { updateExamPartRequest } from '../../../redux/slice/examEditSlice';
import { cloneDeep } from 'lodash';

type Props = {
  examPart: ExamPartImportRequest | null | undefined;
};

export default function EditExamPartView({ examPart }: Props) {
  const [examPartEdit, setExamPartEdit] = useState<ExamPartImportRequest | null | undefined>(examPart);
  const dispatch = useDispatch<AppDispatch>();

  const onChangeInput = function (e: any, field: keyof ExamPartImportRequest) {
    if (!examPartEdit) {
      return;
    }
    const examPartTemp: any = cloneDeep(examPartEdit);
    examPartTemp[field] = e.target.value;
    dispatch(updateExamPartRequest(examPartTemp));
  };

  useEffect(() => {
    setExamPartEdit(examPart);
  }, [examPart]);

  return (
    <form className="w-full h-full p-4 flex flex-col" key={examPart?.id}>
      <div className="flex-1">
        <div className="flex">
          <div className="text-[18px] w-[20%] text-left">Mã phần thi:</div>
          <Input
            placeholder="Mã phần thi"
            name="title"
            className="w-fit"
            value={examPartEdit?.code}
            maxLength={255}
            onChange={(e) => onChangeInput(e, 'code')}
          />
        </div>
        <div className="flex mt-2">
          <div className="text-[18px] w-[20%] text-left">Tên phần thi:</div>
          <TextArea
            placeholder="Tên phần thi"
            name="description"
            className="flex-1 h-[10%] "
            defaultValue={examPartEdit?.name}
            maxLength={255}
            style={{ height: 40, resize: 'none' }}
            onChange={(e) => onChangeInput(e, 'name')}
          />
        </div>
        <div className="flex mt-2">
          <div className="text-[18px] w-[20%] text-left">Nội dung phần thi:</div>
          <TextArea
            placeholder="Nhập nội dung phần thi"
            name="description"
            className="flex-1 h-[30%] "
            defaultValue={examPartEdit?.description}
            style={{ height: 120, resize: 'none' }}
            maxLength={255}
            onChange={(e) => onChangeInput(e, 'description')}
          />
        </div>
      </div>
    </form>
  );
}
